function trackInternalUserDetection() {
  document.body.dispatchEvent(
    new CustomEvent('jb-tracking', {
      detail: {
        event: 'ce_internal_user',
        is_internal_user: true,
      },
    })
  );
}

function isCacheExpired(timestamp: string | null): boolean {
  if (!timestamp) return true;
  const cachedTime = new Date(parseInt(timestamp, 10));
  const now = new Date();
  return now.getTime() - cachedTime.getTime() > 7 * 24 * 60 * 60 * 1000; // 1 week
}

function onLoad() {
  const endpoint = document.body.dataset.internalUserDetectionEndpoint;
  if (!endpoint) {
    return;
  }

  const cachedStatus = localStorage.getItem('isInternalUser');
  const cachedTimestamp = localStorage.getItem('nonInternalUserTimestamp');

  if (cachedStatus === 'true') {
    // Internal user detected previously
    return;
  }

  if (cachedStatus === 'false' && !isCacheExpired(cachedTimestamp)) {
    // Non-internal user detected previously and cache is still valid
    return;
  }

  // Make API request to determine internal user status
  // Check if spoofIP parameter exists in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const spoofIP = urlParams.get('spoofIP');

  // Append spoofIP parameter to the endpoint if it exists
  const apiUrl = spoofIP ? `${endpoint}${endpoint.includes('?') ? '&' : '?'}spoofIP=${spoofIP}` : endpoint;

  fetch(apiUrl).then((response) => {
    if (response.status !== 200) {
      return;
    }
    response.json().then((data) => {
      if (data && data.is_internal_user) {
        // Cache internal user status permanently
        localStorage.setItem('isInternalUser', 'true');
        trackInternalUserDetection();
      } else {
        // Cache non-internal user status with a timestamp
        localStorage.setItem('isInternalUser', 'false');
        localStorage.setItem('nonInternalUserTimestamp', Date.now().toString());
      }
    });
  });
}

if (document.readyState === 'complete') {
  onLoad();
} else {
  window.addEventListener('load', onLoad, { once: true });
}
